"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFormSteps = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var TypeFormSteps = function (props) {
    var steps = props.steps, active = props.active;
    return (React.createElement("ol", { className: "typeform-steps" }, steps.map(function (step, i) {
        return (React.createElement("li", { key: step, className: "" + (active === i ? 'typeform-steps--current' : '') }, step));
    })));
};
exports.TypeFormSteps = TypeFormSteps;
exports.TypeFormSteps.propTypes = {
    active: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};
